// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__3DJWd","header":"styles_header__LAAto","actions":"styles_actions__3hJjk","title":"styles_title__3901l"};